import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import NavBar from '../../components/NavBar';
import image1 from '../../images/course2.jpg';
import './Register.css';

const Register = () => {
  const [formData, setFormData] = useState({
    email: '',
    Fname: '',
    Lname: '',
    password: '',
    password2: '',
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state.user);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await axios.post('https://gyanbackend.aim4u.co.in/reg/', formData);
      setLoading(false);

      const successMessage = document.createElement('div');
      successMessage.className = 'toast-message success';
      successMessage.textContent = 'Registration Successful! Please log in.';
      document.body.appendChild(successMessage);
      setTimeout(() => successMessage.remove(), 5000);

      navigate('/login');
    } catch (error) {
      setLoading(false);
      const errorMessageText =
        error.response?.data?.errors?.email ||
        error.response?.data?.errors?.non_field_errors ||
        'Registration failed';

      setError(errorMessageText);

      const errorMessage = document.createElement('div');
      errorMessage.className = 'toast-message error';
      errorMessage.textContent = `Registration Failed: ${errorMessageText}`;
      document.body.appendChild(errorMessage);
      setTimeout(() => errorMessage.remove(), 5000);
    }
  };

  return (
    <div className="register-container">
      {isAuthenticated && <NavBar name="Register" />}
      {loading && (
        <div className="loading-overlay">
          <div className="loader"></div>
        </div>
      )}

      <div className="register-content">
        <div className="image-section">
          <img src={image1 || "/placeholder.svg"} alt="Registration" className="register-image" />
        </div>

        <div className="form-section">
          <div className="form-header">
            <h1>
              Welcome to <span className="highlight">Gyan@AiM4u</span>
            </h1>
            <h2>Let's get you started</h2>
          </div>

          <form onSubmit={handleSubmit} className="register-form">
            <div className="form-group">
              <label htmlFor="Fname">First Name</label>
              <input
                type="text"
                id="Fname"
                name="Fname"
                value={formData.Fname}
                onChange={handleChange}
                required
                placeholder="Enter your First Name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="Lname">Last Name</label>
              <input
                type="text"
                id="Lname"
                name="Lname"
                value={formData.Lname}
                onChange={handleChange}
                required
                placeholder="Enter your Last Name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="Enter your Email Address"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">
                Password
                <span className="password-hint">(At least 8 letters and one uppercase character)</span>
              </label>
              <div className="password-toggle-wrapper">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  placeholder="Enter your Password"
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="password2">Confirm Password</label>
              <div className="password-toggle-wrapper">
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  id="password2"
                  name="password2"
                  value={formData.password2}
                  onChange={handleChange}
                  required
                  placeholder="Confirm your Password"
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  <i className={`fas ${showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>
              </div>
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" className="submit-button" disabled={loading}>
              Register
            </button>
          </form>

          <p className="login-link">
            Already Have an Account? <Link to="/login">Login</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;